import {
  buildNormalizedDay,
  buildNormalizedPilotBlueprint,
  localizedGenderNode,
} from "./referenceNormalizerPilotUtils";

/** DNA validator: writing phrase appears in runtime output from buildNormalizedDay + pilot utils. */
export const DNA_VALIDATE_WRITING_PHRASE = "אני שואל/ת את עצמי בשקט";

const days = [
  {
    dayNumber: 1,
    emotionalStage: "pause",
    title: "לזהות את ההתקף",
    opening: localizedGenderNode(
      [
      "היום אני לא נלחם/ת בהתקף.",
      "אני רק מזהה: זה קורה."
    ],
      [
      "היום אני לא נלחם/ת בהתקף.",
      "אני רק מזהה: זה קורה."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "אני עוצר/ת עם עצמי.",
      "נשימה אחת."
    ],
      [
      "אני עוצר/ת עם עצמי.",
      "נשימה אחת."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "איך ההתקף מרגיש בגוף?",
      "מה הסימן הראשון שהוא מתחיל?",
      "מה אני מפחד/ת שיקרה ברגע הזה?"
    ],
      [
      "איך ההתקף מרגיש בגוף?",
      "מה הסימן הראשון שהוא מתחיל?",
      "מה אני מפחד/ת שיקרה ברגע הזה?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "זה גל, לא סכנה."
    ],
      [
      "זה גל, לא סכנה."
    ]
    ),
    action: localizedGenderNode(
      "נשימה אחת + \"אני בתוך גל\".",
      "נשימה אחת + \"אני בתוך גל\"."
    ),
  },
  {
    dayNumber: 2,
    emotionalStage: "pain",
    title: "הרגע הראשון",
    opening: localizedGenderNode(
      [
      "היום אני שם/ה לב לרגע שההתקף מתחיל.",
      "אני רק מבחין/ה."
    ],
      [
      "היום אני שם/ה לב לרגע שההתקף מתחיל.",
      "אני רק מבחין/ה."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "אני יושב/ת עם עצמי רגע.",
      "נשימה אחת."
    ],
      [
      "אני יושב/ת עם עצמי רגע.",
      "נשימה אחת."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "מה קרה רגע לפני?",
      "איפה הייתי כשזה התחיל?",
      "מה הגוף עושה קודם?"
    ],
      [
      "מה קרה רגע לפני?",
      "איפה הייתי כשזה התחיל?",
      "מה הגוף עושה קודם?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "ברגע הראשון יש לי מעט מרחב."
    ],
      [
      "ברגע הראשון יש לי מעט מרחב."
    ]
    ),
    action: localizedGenderNode(
      "נשימה אחת כשההתקף מתחיל.",
      "נשימה אחת כשההתקף מתחיל."
    ),
  },
  {
    dayNumber: 3,
    emotionalStage: "pain",
    title: "אותות הגוף",
    opening: localizedGenderNode(
      [
      "היום אני מקשיב/ה לגוף לפני הסיפור.",
      "אני נשאר/ת איתי."
    ],
      [
      "היום אני מקשיב/ה לגוף לפני הסיפור.",
      "אני נשאר/ת איתי."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "אני שם/ה לב לנשימה.",
      "נשימה אחת."
    ],
      [
      "אני שם/ה לב לנשימה.",
      "נשימה אחת."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "איפה הדופק מורגש הכי חזק?",
      "מה הגוף מנסה להגן?",
      "מה יכול להרפות קצת?"
    ],
      [
      "איפה הדופק מורגש הכי חזק?",
      "מה הגוף מנסה להגן?",
      "מה יכול להרפות קצת?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "הגוף מנסה לשמור עלי."
    ],
      [
      "הגוף מנסה לשמור עלי."
    ]
    ),
    action: localizedGenderNode(
      "יד על החזה ונשימה אחת.",
      "יד על החזה ונשימה אחת."
    ),
  },
  {
    dayNumber: 4,
    emotionalStage: "pattern",
    title: "הסיפור של הסכנה",
    opening: localizedGenderNode(
      [
      "היום אני מזהה את הסיפור שמספר סכנה.",
      "אני לא נלחם/ת בו."
    ],
      [
      "היום אני מזהה את הסיפור שמספר סכנה.",
      "אני לא נלחם/ת בו."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "אני נושם/ת פנימה והחוצה.",
      "נשימה אחת."
    ],
      [
      "אני נושם/ת פנימה והחוצה.",
      "נשימה אחת."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "איזה תסריט קופץ מיד?",
      "מה בו הכי מפחיד?",
      "איזו אפשרות רכה יכולה להיות גם אמת?"
    ],
      [
      "איזה תסריט קופץ מיד?",
      "מה בו הכי מפחיד?",
      "איזו אפשרות רכה יכולה להיות גם אמת?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "סיפור הוא לא עובדה."
    ],
      [
      "סיפור הוא לא עובדה."
    ]
    ),
    action: localizedGenderNode(
      "משפט פנימי - \"זה סיפור שעולה\".",
      "משפט פנימי - \"זה סיפור שעולה\"."
    ),
  },
  {
    dayNumber: 5,
    emotionalStage: "pattern",
    title: "הפחד שמתחת",
    opening: localizedGenderNode(
      [
      "היום אני נוגע/ת בפחד שמתחת להתקף.",
      "אני נשאר/ת איתו רגע."
    ],
      [
      "היום אני נוגע/ת בפחד שמתחת להתקף.",
      "אני נשאר/ת איתו רגע."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "אני נושם/ת לאט.",
      "נשימה אחת."
    ],
      [
      "אני נושם/ת לאט.",
      "נשימה אחת."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "ממה אני מפחד/ת שיקרה?",
      "מה הכי כואב במחשבה הזו?",
      "מה הייתי בוחר/ת/ה לשמוע עכשיו?"
    ],
      [
      "ממה אני מפחד/ת שיקרה?",
      "מה הכי כואב במחשבה הזו?",
      "מה הייתי בוחר/ת/ה לשמוע עכשיו?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "פחד רוצה הגנה, לא מלחמה."
    ],
      [
      "פחד רוצה הגנה, לא מלחמה."
    ]
    ),
    action: localizedGenderNode(
      "לקרוא לפחד בשם בשקט.",
      "לקרוא לפחד בשם בשקט."
    ),
  },
  {
    dayNumber: 6,
    emotionalStage: "fear",
    title: "קצב הגוף",
    opening: localizedGenderNode(
      [
      "היום אני נותן/ת לגוף קצב איטי.",
      "רק רגע."
    ],
      [
      "היום אני נותן/ת לגוף קצב איטי.",
      "רק רגע."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "אני נושם/ת לאט וסופר/ת נשימה אחת.",
      "נשימה אחת."
    ],
      [
      "אני נושם/ת לאט וסופר/ת נשימה אחת.",
      "נשימה אחת."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "מה מרגיע את הגוף אפילו קצת?",
      "מה הגוף מבקש ממני?",
      "איך אני יודע/ת שהוא נרגע מעט?"
    ],
      [
      "מה מרגיע את הגוף אפילו קצת?",
      "מה הגוף מבקש ממני?",
      "איך אני יודע/ת שהוא נרגע מעט?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "קצב איטי הוא עוגן."
    ],
      [
      "קצב איטי הוא עוגן."
    ]
    ),
    action: localizedGenderNode(
      "נשימה איטית אחת.",
      "נשימה איטית אחת."
    ),
  },
  {
    dayNumber: 7,
    emotionalStage: "need",
    title: "הצורך בביטחון",
    opening: localizedGenderNode(
      [
      "היום אני נוגע/ת בצורך בביטחון שמתחת להתקף.",
      "אני נשאר/ת איתי."
    ],
      [
      "היום אני נוגע/ת בצורך בביטחון שמתחת להתקף.",
      "אני נשאר/ת איתי."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "אני נושם/ת לאט.",
      "נשימה אחת."
    ],
      [
      "אני נושם/ת לאט.",
      "נשימה אחת."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "מה אני בוחר/ת/ה כדי להרגיש בטוח/ה?",
      "מה יכול לעזור לגוף להירגע?",
      "מה הייתי רוצה לתת לעצמי עכשיו?"
    ],
      [
      "מה אני בוחר/ת/ה כדי להרגיש בטוח/ה?",
      "מה יכול לעזור לגוף להירגע?",
      "מה הייתי רוצה לתת לעצמי עכשיו?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "ביטחון קטן משנה את הטון."
    ],
      [
      "ביטחון קטן משנה את הטון."
    ]
    ),
    action: localizedGenderNode(
      "לכתוב מילה אחת של ביטחון.",
      "לכתוב מילה אחת של ביטחון."
    ),
  },
  {
    dayNumber: 8,
    emotionalStage: "softening",
    title: "להניח רגע",
    opening: localizedGenderNode(
      [
      "היום אני בודק/ת איך זה מרגיש להניח את ההתקף לרגע.",
      "רק רגע."
    ],
      [
      "היום אני בודק/ת איך זה מרגיש להניח את ההתקף לרגע.",
      "רק רגע."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "אני נותן/ת לגוף להתרכך מעט.",
      "נשימה אחת."
    ],
      [
      "אני נותן/ת לגוף להתרכך מעט.",
      "נשימה אחת."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "מה קורה בי כשאני מניח/ה לרגע?",
      "מה מפחיד אותי בלהניח?",
      "מה מרגיע אותי אפילו קצת?"
    ],
      [
      "מה קורה בי כשאני מניח/ה לרגע?",
      "מה מפחיד אותי בלהניח?",
      "מה מרגיע אותי אפילו קצת?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "להניח לרגע זו גם בחירה."
    ],
      [
      "להניח לרגע זו גם בחירה."
    ]
    ),
    action: localizedGenderNode(
      "רגע אחד בלי להילחם בגוף.",
      "רגע אחד בלי להילחם בגוף."
    ),
  },
  {
    dayNumber: 9,
    emotionalStage: "softening",
    title: "שפה פנימית רכה",
    opening: localizedGenderNode(
      [
      "היום אני בוחר/ת לדבר אל עצמי ברוך.",
      "לא בכוח."
    ],
      [
      "היום אני בוחר/ת לדבר אל עצמי ברוך.",
      "לא בכוח."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "אני נושם/ת ושם/ה לב לקול הפנימי.",
      "נשימה אחת."
    ],
      [
      "אני נושם/ת ושם/ה לב לקול הפנימי.",
      "נשימה אחת."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "איך אני מדבר/ת אל עצמי בזמן התקף?",
      "איך הייתי רוצה לשמוע את זה?",
      "מה המשפט הרך שלי?"
    ],
      [
      "איך אני מדבר/ת אל עצמי בזמן התקף?",
      "איך הייתי רוצה לשמוע את זה?",
      "מה המשפט הרך שלי?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "קול רך מוריד לחץ."
    ],
      [
      "קול רך מוריד לחץ."
    ]
    ),
    action: localizedGenderNode(
      "לומר את המשפט הרך פעם אחת.",
      "לומר את המשפט הרך פעם אחת."
    ),
  },
  {
    dayNumber: 10,
    emotionalStage: "perspective",
    title: "רגע לפני בריחה",
    opening: localizedGenderNode(
      [
      "היום אני עוצר/ת רגע לפני שאני בורח/ת.",
      "רק רגע."
    ],
      [
      "היום אני עוצר/ת רגע לפני שאני בורח/ת.",
      "רק רגע."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "אני שם/ה לב לדחף לברוח.",
      "נשימה אחת."
    ],
      [
      "אני שם/ה לב לדחף לברוח.",
      "נשימה אחת."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "ממה אני מנסה לברוח?",
      "מה יקרה אם אשאר רגע?",
      "מה יכול לתמוך בי רגע אחד?"
    ],
      [
      "ממה אני מנסה לברוח?",
      "מה יקרה אם אשאר רגע?",
      "מה יכול לתמוך בי רגע אחד?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "רגע קטן משנה כיוון."
    ],
      [
      "רגע קטן משנה כיוון."
    ]
    ),
    action: localizedGenderNode(
      "נשימה אחת לפני בריחה.",
      "נשימה אחת לפני בריחה."
    ),
  },
  {
    dayNumber: 11,
    emotionalStage: "strength",
    title: "לחזור להווה",
    opening: localizedGenderNode(
      [
      "היום אני חוזר/ת לרגע הזה.",
      "אני איתי."
    ],
      [
      "היום אני חוזר/ת לרגע הזה.",
      "אני איתי."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "אני מרגיש/ה את משקל הגוף.",
      "נשימה אחת."
    ],
      [
      "אני מרגיש/ה את משקל הגוף.",
      "נשימה אחת."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "מה אני שומע/ת עכשיו?",
      "מה אני רואה סביבי?",
      "מה אני מרגיש/ה ממש ברגע הזה?"
    ],
      [
      "מה אני שומע/ת עכשיו?",
      "מה אני רואה סביבי?",
      "מה אני מרגיש/ה ממש ברגע הזה?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "ההווה נותן לי קרקע."
    ],
      [
      "ההווה נותן לי קרקע."
    ]
    ),
    action: localizedGenderNode(
      "להרגיש את כפות הרגליים לרגע.",
      "להרגיש את כפות הרגליים לרגע."
    ),
  },
  {
    dayNumber: 12,
    emotionalStage: "release",
    title: "רגע לפני בדיקה",
    opening: localizedGenderNode(
      [
      "היום אני עוצר/ת רגע לפני שאני בודק/ת אם זה עובר.",
      "רק רגע."
    ],
      [
      "היום אני עוצר/ת רגע לפני שאני בודק/ת אם זה עובר.",
      "רק רגע."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "אני שם/ה לב לדחף לבדוק.",
      "נשימה אחת."
    ],
      [
      "אני שם/ה לב לדחף לבדוק.",
      "נשימה אחת."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "מה אני מחפש/ת לוודא?",
      "מה יקרה אם לא אדע מיד?",
      "מה יכול לעזור לי להמתין רגע?"
    ],
      [
      "מה אני מחפש/ת לוודא?",
      "מה יקרה אם לא אדע מיד?",
      "מה יכול לעזור לי להמתין רגע?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "להמתין רגע זה כוח שקט."
    ],
      [
      "להמתין רגע זה כוח שקט."
    ]
    ),
    action: localizedGenderNode(
      "לעצור רגע לפני בדיקה.",
      "לעצור רגע לפני בדיקה."
    ),
  },
  {
    dayNumber: 13,
    emotionalStage: "choice",
    title: "צעד קטן",
    opening: localizedGenderNode(
      [
      "היום אני בוחר/ת צעד קטן שמרגיע אותי.",
      "לא מהפכה."
    ],
      [
      "היום אני בוחר/ת צעד קטן שמרגיע אותי.",
      "לא מהפכה."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "אני נושם/ת לאט ומביט/ה סביבי.",
      "נשימה אחת."
    ],
      [
      "אני נושם/ת לאט ומביט/ה סביבי.",
      "נשימה אחת."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "איזה צעד קטן יכול לעזור לי להירגע?",
      "מתי אני יכול/ה לעשות אותו?",
      "מה יעזור לי לזכור?"
    ],
      [
      "איזה צעד קטן יכול לעזור לי להירגע?",
      "מתי אני יכול/ה לעשות אותו?",
      "מה יעזור לי לזכור?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "קטן מספיק הוא מספיק."
    ],
      [
      "קטן מספיק הוא מספיק."
    ]
    ),
    action: localizedGenderNode(
      "לבחור צעד קטן אחד.",
      "לבחור צעד קטן אחד."
    ),
  },
  {
    dayNumber: 14,
    emotionalStage: "continuation",
    title: "משפט חזרה",
    opening: localizedGenderNode(
      [
      "היום אני מסיים/ת עם משפט שמחזיר אותי לעצמי.",
      "אני בוחר/ת נוכחות."
    ],
      [
      "היום אני מסיים/ת עם משפט שמחזיר אותי לעצמי.",
      "אני בוחר/ת נוכחות."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "אני עוצר/ת רגע לפני תגובה.",
      "נשימה אחת."
    ],
      [
      "אני עוצר/ת רגע לפני תגובה.",
      "נשימה אחת."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "מה למדתי על ההתקפים האלה?",
      "מה הסימן הראשון שהם עולים?",
      "מה המשפט הקצר שלי?"
    ],
      [
      "מה למדתי על ההתקפים האלה?",
      "מה הסימן הראשון שהם עולים?",
      "מה המשפט הקצר שלי?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "אני בוחר/ת רגע לפני תגובה."
    ],
      [
      "אני בוחר/ת רגע לפני תגובה."
    ]
    ),
    action: localizedGenderNode(
      "נשימה אחת + המשפט שלי.",
      "נשימה אחת + המשפט שלי."
    ),
  },
].map(buildNormalizedDay);

export const anxietyPanicAttacksBlueprintHe = buildNormalizedPilotBlueprint({
  id: "anxiety_panic_attacks_14d",
  version: "tri_locale_emit_he_v1",
  durationDays: 14,
  problemKey: "anxiety_panic_attacks",
  category: "anxiety",
  journeyName: {
    he: "התקפי חרדה חוזרים (דופק, קוצר נשימה)",
    en: "Recurrent anxiety attacks (palpitations, shortness of breath)",
    es: "Ataques de ansiedad recurrentes (palpitaciones, dificultad para respirar)",
  },
  days,
});

export default anxietyPanicAttacksBlueprintHe;
